import { FC } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { LockLockedIcon } from "mds/icons";

export const TemplatePageDisabledBanner: FC = () => (
  <Banner className="w-full text-sm" Icon={LockLockedIcon} kind="error">
    {t("warning.template_page_disabled")}
  </Banner>
);
